import React,{useEffect,useState} from "react";
import CardSkil from "../CardSkill";
import './styles.scss'
import { onValue, ref } from "firebase/database";
import { db } from "../../db";
import { ISkills } from "../../Interfaces/ISkills";
import { TimesTI } from "./TimesTI";


const Habilidades = () => {

    const [list, setList] = useState<ISkills[]>([]);
    useEffect(() => {
        const refSkills = ref(db,'skills')
        onValue(refSkills, result => {
            const resultSkill = Object.entries<ISkills>(result.val() ?? {})
            .map(([key,value]) => {
              return {
                'ID':key,
                'skill':value.skill,
                'area':value.area
              }
            })
            setList(resultSkill)
        })
      },[])

    return (
        <section className="HabilidadesField">
            <div className="HabilidadesConteiner">
                <h5>Conhecimentos</h5>
                <div className="SkillField">
                    {TimesTI.map(time => 
                         <CardSkil
                            key={time.area}
                            title={time.area}
                            corArea={time.cor}
                            itens={list.filter(item => item.area === time.area)}
                         />   
                        )
                    }
                </div>
            </div>
        </section>
    );
}
export default Habilidades
